var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "form-search__main" };
var _hoisted_2 = { class: "form-search__control" };
var _hoisted_3 = {
    key: 0,
    class: "form-label"
};
var _hoisted_4 = ["name", "id", "required", "placeholder", "onKeyup"];
var _hoisted_5 = { class: "form-field__side form-field__side--right" };
var _hoisted_6 = ["open"];
var _hoisted_7 = {
    key: 0,
    class: "smart-result__list"
};
var _hoisted_8 = ["onClick", "innerHTML"];
import { emitsComponent, propsComponent, useDaData } from 'vue-dadata-3';
import FormControl from "./form/FormControl.vue";
import Icon from "./Icon.vue";
import { computed, ref, watch } from "vue";
import { formatAddress, formatCityResults, formatSelectedCity, isCityArea } from "./order/city_helpers";
import { isFullyVisible } from "../utils";
import resettableValue from "../tools/resettable_value";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VueDadata',
    props: __assign(__assign({ teleport: Object, label: String }, propsComponent), { setInputValue: {
            type: Function,
            default: function (item) {
                if (item.data.street || item.data.house || item.data.flat) {
                    return formatAddress(item);
                }
                if (item.data.city || item.data.settlement) {
                    return formatSelectedCity(item);
                }
                return item.value;
            },
        }, enabledCacheQuery: { type: Boolean, default: true }, clearOnFocus: Boolean, selectOnBlur: Boolean, required: Boolean, error: String }),
    emits: __spreadArray(__spreadArray([], __read(emitsComponent), false), ['reset'], false),
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var cityMode = computed(function () { return ['city', 'settlement'].includes(props.toBound); });
        var addressMode = computed(function () { return props.fromBound === 'street' && props.toBound === 'flat'; });
        var filteredSuggestions = computed(function () {
            if (!suggestions.value) {
                return [];
            }
            return suggestions.value.filter(function (suggestion) {
                var _a;
                if (suggestion.data.region === 'Байконур') {
                    return false;
                }
                if (addressMode.value) {
                    return true;
                }
                if (cityMode.value && isCityArea(suggestion)) {
                    return false;
                }
                return !(((_a = suggestion.data.city_district_type) === null || _a === void 0 ? void 0 : _a.match(/^(р-н|округ)$/)) && !suggestion.data.settlement);
            });
        });
        function onBlur(event) {
            if (event.relatedTarget === dialog.value) {
                return;
            }
            if (!suggestions.value.length) {
                emit('reset');
            }
            setTimeout(function () {
                if (showList.value) {
                    if (suggestions.value.length && props.selectOnBlur) {
                        onSelected(filteredSuggestions.value[activeIndex.value === -1 ? 0 : activeIndex.value]);
                    }
                    else {
                        showList.value = false;
                    }
                }
            }, 50);
        }
        var activeIndex = ref(-1);
        var empty = computed(function () { var _a; return ((_a = filteredSuggestions.value) === null || _a === void 0 ? void 0 : _a.length) < 1; });
        var minKey = computed(function () { return empty.value ? -1 : 0; });
        var maxKey = computed(function () { return empty.value ? -1 : filteredSuggestions.value.length - 1; });
        var listItemRefs = ref([]);
        var dialog = ref();
        var clearOnFocus = props.clearOnFocus;
        var _b = useDaData(), localValue = _b.localValue, suggestions = _b.suggestions, computedCssClasses = _b.computedCssClasses, dadataDom = _b.dadataDom, onSelected = _b.onSelected, onFocus = _b.onFocus, onInput = _b.onInput, showList = _b.showList, restoreSuggestion = _b.restoreSuggestion;
        var error = resettableValue(function () { return props.error; }, function () { return localValue; });
        __expose({ restoreSuggestion: restoreSuggestion });
        function onkeyup() {
            activeIndex.value = activeIndex.value === -1 ? maxKey.value : activeIndex.value === 0 ? 0 : activeIndex.value - 1;
        }
        function onkeydown() {
            activeIndex.value = activeIndex.value === -1 ? minKey.value : activeIndex.value === maxKey.value ? maxKey.value : activeIndex.value + 1;
        }
        function itemClasses(index) {
            var _a;
            return _a = {},
                _a["".concat(computedCssClasses.value.listEmpty)] = suggestions.value.length === 0,
                _a['is-active'] = index === activeIndex.value,
                _a;
        }
        function onenter() {
            if (empty.value) {
                return;
            }
            onSelected(filteredSuggestions.value[activeIndex.value === -1 ? 0 : activeIndex.value]);
        }
        function onSuggestionClick(index, item) {
            activeIndex.value = index;
            onSelected(item);
        }
        watch(filteredSuggestions, function (value, oldValue) {
            var _a;
            if (activeIndex.value === -1) {
                return;
            }
            var oldSuggestion = (_a = oldValue[activeIndex.value]) !== null && _a !== void 0 ? _a : null;
            if (!oldSuggestion) {
                activeIndex.value = -1;
                return;
            }
            activeIndex.value = value.findIndex(function (i) {
                return i.unrestricted_value === oldSuggestion.unrestricted_value;
            });
        });
        watch(activeIndex, function (value) {
            if (value === -1) {
                return;
            }
            if (!isFullyVisible(dialog.value)) {
                dialog.value.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                });
                return;
            }
            if (isFullyVisible(listItemRefs.value[value], dialog.value)) {
                return;
            }
            listItemRefs.value[value].scrollIntoView({
                block: "nearest",
                behavior: "auto",
            });
        });
        watch(showList, function (value) {
            if (!value || !props.teleport) {
                return;
            }
            var inputRect = dadataDom.value.getBoundingClientRect();
            var teleportRect = props.teleport.getBoundingClientRect();
            dialog.value.style.left = "".concat(inputRect.left - teleportRect.left, "px");
            dialog.value.style.right = "".concat(teleportRect.right - inputRect.right, "px");
            dialog.value.style.top = "".concat(inputRect.top - teleportRect.top + inputRect.height, "px");
            dialog.value.style.width = 'auto';
        });
        function prepareResults(item) {
            if (cityMode.value) {
                return formatCityResults('', localValue.value, item);
            }
            else if (addressMode.value) {
                return formatAddress(item);
            }
            return item.value;
        }
        function onFocusHandler(event) {
            if (clearOnFocus) {
                localValue.value = '';
                clearOnFocus = false;
            }
            else {
                onFocus(event);
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(FormControl, {
                        required: __props.required,
                        error: _unref(error)
                    }, {
                        default: _withCtx(function () { return [
                            (__props.label)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("div", {
                                ref_key: "dadataDom",
                                ref: dadataDom,
                                class: "form-field form-field--text form-field--1 form-field--m form-field--primary"
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control", _unref(computedCssClasses).input]),
                                    name: _ctx.inputName,
                                    id: _ctx.inputId,
                                    autocomplete: "off",
                                    required: __props.required,
                                    placeholder: _ctx.placeholder,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(localValue) ? (localValue).value = $event : null); }),
                                    onKeydown: [
                                        _cache[1] || (_cache[1] = _withKeys(_withModifiers(function () { }, ["prevent"]), ["up"])),
                                        _cache[2] || (_cache[2] = _withKeys(_withModifiers(function () { }, ["prevent"]), ["down"])),
                                        _cache[3] || (_cache[3] = _withKeys(_withModifiers(function () { }, ["prevent"]), ["enter"]))
                                    ],
                                    onKeyup: [
                                        _withKeys(onkeyup, ["up"]),
                                        _withKeys(_withModifiers(onkeydown, ["prevent"]), ["down"]),
                                        _withKeys(_withModifiers(onenter, ["prevent"]), ["enter"])
                                    ],
                                    onInput: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        function () {
                                            var args = [];
                                            for (var _i = 0; _i < arguments.length; _i++) {
                                                args[_i] = arguments[_i];
                                            }
                                            return (_unref(onInput) && _unref(onInput).apply(void 0, __spreadArray([], __read(args), false)));
                                        }),
                                    onFocus: onFocusHandler,
                                    onBlur: onBlur
                                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4), [
                                    [_vModelText, _unref(localValue)]
                                ]),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(Icon, {
                                        name: "search",
                                        "class-name": "form-icon"
                                    })
                                ])
                            ], 512 /* NEED_PATCH */),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _renderSlot(_ctx.$slots, "default")
                        ]; }),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["required", "error"])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (_openBlock(), _createBlock(_Teleport, {
                    disabled: !__props.teleport,
                    to: __props.teleport
                }, [
                    _createElementVNode("dialog", {
                        class: "form-search__result smart-result",
                        open: _unref(showList) && filteredSuggestions.value.length > 0,
                        ref_key: "dialog",
                        ref: dialog
                    }, [
                        (_unref(showList))
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSuggestions.value, function (item, index) {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass(["smart-result__item", itemClasses(index)]),
                                        key: index,
                                        onClick: function ($event) { return (onSuggestionClick(index, item)); },
                                        innerHTML: prepareResults(item),
                                        ref_for: true,
                                        ref_key: "listItemRefs",
                                        ref: listItemRefs
                                    }, null, 10 /* CLASS, PROPS */, _hoisted_8));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_6)
                ], 8 /* PROPS */, ["disabled", "to"]))
            ]));
        };
    }
});
